import { useState, useCallback } from 'react';
import { type ConfirmationModalProps } from '@components/modal/ConfirmationModal';

/**
 * Return props to use with ConfirmationModal
 * and functions to open and set props
 */
const useConfirmationModal = () => {
  const [modalProps, setModalProps] = useState<ConfirmationModalProps>({
    open: false,
    onClose: () => {
      setModalProps((previous) => ({ ...previous, open: false }));
    },
  });

  const openConfirmationModal = useCallback(
    (onConfirm: () => void | Promise<unknown>, modalProps?: Partial<ConfirmationModalProps>) => {
      setModalProps((previous) => ({
        ...previous,
        open: true,
        ...modalProps,
        submitButton: {
          onClick: () => {
            const result = onConfirm();
            // Si onConfirm es async (ej. una mutation), mantiene el modal abierto con el botón
            // en loading hasta que resuelva — evita cerrar el modal antes de que la operación
            // termine, dejando al usuario sin feedback mientras espera.
            if (result instanceof Promise) {
              setModalProps((previous) => ({
                ...previous,
                submitButton: { ...previous.submitButton, loading: true },
              }));
              result.finally(() => {
                setModalProps((previous) => ({ ...previous, open: false }));
              });
              return;
            }
            setModalProps((previous) => ({ ...previous, open: false }));
          },
          ...modalProps?.submitButton,
        },
      }));
    },
    [setModalProps],
  );

  return {
    confirmationModalProps: modalProps,
    openConfirmationModal,
    setConfirmationModal: setModalProps,
  };
};

export default useConfirmationModal;
